/* 🤖 this file was generated by svg-to-ts */
export const matIconVerticalShadesClosed: {
  name: 'vertical-shades-closed';
  data: string;
} = {
  name: 'vertical-shades-closed',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 19V3H4v16H2v2h20v-2h-2zM13 5h1.5v14H13V5zm-2 14H9.5V5H11v14zM6 5h1.5v14H6V5zm10.5 14V5H18v14h-1.5z"/></svg>`
};
